(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-backup-custom-quote-20260830"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.gm-custom-quote';

    const setControlValue = (control, value) => {
      if (!control || control.value === value) return;
      const prototype = control.tagName === 'SELECT'
        ? HTMLSelectElement.prototype
        : control.tagName === 'TEXTAREA'
          ? HTMLTextAreaElement.prototype
          : HTMLInputElement.prototype;
      const setter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

      if (setter) setter.call(control, value);
      else control.value = value;

      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const updateLabel = (control, text) => {
      if (!control) return;
      const labelId = control?.getAttribute('aria-labelledby');
      const labelledElement = labelId ? document.getElementById(labelId) : null;
      const associatedLabel = control.labels?.[0] || null;
      const field = control.closest('.pmyf-element') || control.closest('.pmyf-input');
      const nearbyLabel = field?.querySelector('.pmyf-input-label, label') || null;
      const label = labelledElement || associatedLabel || nearbyLabel;
      if (!label) return;

      if (!control.id) {
        const fieldName = (control.name || control.type || 'field').replace(/[^a-z0-9_-]/gi, '-');
        let nextId = `gm-custom-${fieldName}`;
        let suffix = 2;
        while (document.getElementById(nextId)) {
          nextId = `gm-custom-${fieldName}-${suffix}`;
          suffix += 1;
        }
        control.id = nextId;
      }

      if (label.tagName === 'LABEL') {
        label.htmlFor = control.id;
      } else {
        if (!label.id) label.id = `${control.id}-label`;
        control.setAttribute('aria-labelledby', label.id);
      }

      if (label.textContent !== text) label.textContent = text;
    };

    const requireControl = (control, label) => {
      if (!control) return;
      control.required = true;
      control.setAttribute('aria-required', 'true');
      updateLabel(control, label);
    };

    const selectedPackage = () => {
      const option = document.querySelector('form[action="/cart/add"] input.selector[type="radio"]:checked');
      return option?.value || 'Design + Silicone Prototype Deposit';
    };

    const purchaseButtonCopy = (packageName) => {
      if (packageName.includes('Prototype')) return 'Purchase Prototype Deposit';
      const quantity = packageName.match(/^\d+/)?.[0];
      return quantity ? `Purchase ${quantity}-Mold Package` : 'Purchase Selected Package';
    };

    const updatePurchaseButton = () => {
      const button = document.querySelector('[data-custom-package-atc]');
      if (!button) return;
      const copy = purchaseButtonCopy(selectedPackage());
      button.dataset.atc = copy;
      if (!button.disabled) button.textContent = copy;
    };

    const prefillPackage = (form) => {
      const details = form.querySelector('textarea[name="textarea-3"]');
      if (!details) return;

      const nextLine = `Selected package: ${selectedPackage()}`;
      const current = details.value.trim();
      if (!current) {
        setControlValue(details, `${nextLine}\nProduction method or depositor: \nTarget launch date: `);
      } else if (current.startsWith('Selected package:')) {
        setControlValue(details, current.replace(/^Selected package:[^\n]*/, nextLine));
      }
    };

    const enhanceQuoteForm = (section) => {
      const form = section.querySelector('.pmyf-form');
      if (!form) return;

      const heading = form.querySelector('.pmyf-heading h2');
      if (heading) {
        const headingCopy = 'Project details';
        if (heading.textContent !== headingCopy) heading.textContent = headingCopy;
        const intro = heading.parentElement?.querySelector('div');
        const introCopy = 'Complete the required fields below. Artwork and equipment details are optional.';
        if (intro && intro.textContent !== introCopy) intro.textContent = introCopy;
      }

      const projectType = form.querySelector('select[name="dropdown"]');
      if (projectType) {
        let customOption = projectType.querySelector('option[value="custom"]');
        if (!customOption) {
          customOption = document.createElement('option');
          customOption.value = 'custom';
          projectType.appendChild(customOption);
        }
        if (customOption.textContent.trim() !== 'Custom Gummy Mold') {
          customOption.textContent = 'Custom Gummy Mold';
        }
        setControlValue(projectType, 'custom');
        const projectTypeField = projectType.closest('.pmyf-element');
        if (projectTypeField) {
          projectTypeField.hidden = true;
          projectTypeField.setAttribute('aria-hidden', 'true');
        }
      }

      const fullName = form.querySelector('input[name="fullName"]');
      requireControl(fullName, 'Full name *');

      const email = form.querySelector('input[name="email"]');
      requireControl(email, 'Email *');

      const phone = form.querySelector('input[name="phone"]');
      updateLabel(phone, 'Phone (optional)');
      const countryCode = phone?.closest('.pmyf-element')?.querySelector('select');
      if (countryCode && !countryCode.hasAttribute('aria-label') && !countryCode.hasAttribute('aria-labelledby')) {
        countryCode.setAttribute('aria-label', 'Country calling code');
      }

      const company = form.querySelector('input[name="company"]');
      updateLabel(company, 'Company (optional)');

      const shape = form.querySelector('textarea[name="textarea"]');
      requireControl(shape, 'Desired shape or concept *');
      if (shape) shape.placeholder = 'Example: logo, bear, fruit, character, or reference shape';

      const size = form.querySelector('textarea[name="textarea-2"]');
      requireControl(size, 'Desired gummy size, weight, or volume *');
      if (size) size.placeholder = 'Example: 2.5 mL, 4 g, 20 mm — or enter “not sure yet”';

      const attachment = form.querySelector('input[name="attachment"]');
      if (attachment) {
        attachment.required = false;
        attachment.removeAttribute('required');
        attachment.removeAttribute('aria-required');
        attachment.removeAttribute('data-required');
        attachment.setCustomValidity('');
        updateLabel(attachment, 'Upload logo, artwork, or reference file (optional)');
      }

      const details = form.querySelector('textarea[name="textarea-3"]');
      updateLabel(details, 'Production details and desired timeline (optional)');
      prefillPackage(form);
    };

    const updateInternalLinks = () => {
      document.querySelectorAll('#content.product-page a[href="/pages/contact-us"]').forEach((link) => {
        const copy = link.textContent.toLowerCase();
        if (copy.includes('quote') || copy.includes('production team')) link.href = '#custom-quote';
      });
    };

    const enhanceAll = () => {
      document.querySelectorAll(sectionSelector).forEach(enhanceQuoteForm);
      updatePurchaseButton();
      updateInternalLinks();
    };

    const start = () => {
      enhanceAll();

      document.querySelectorAll(sectionSelector).forEach((section) => {
        if (section.dataset.gmQuoteObserved === 'true') return;
        section.dataset.gmQuoteObserved = 'true';
        const observerOptions = { childList: true, subtree: true };
        const observer = new MutationObserver(() => {
          observer.disconnect();
          enhanceQuoteForm(section);
          observer.observe(section, observerOptions);
        });
        observer.observe(section, observerOptions);
      });

      if (document.documentElement.dataset.gmCustomFunnelBound !== 'true') {
        document.documentElement.dataset.gmCustomFunnelBound = 'true';
        document.addEventListener('change', (event) => {
          if (!event.target.matches('form[action="/cart/add"] input.selector[type="radio"]')) return;
          updatePurchaseButton();
          document.querySelectorAll(sectionSelector).forEach((section) => {
            const form = section.querySelector('.pmyf-form');
            if (form) prefillPackage(form);
          });
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-backup-custom-quote-post-js-20260830"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.gm-custom-quote';

    const setControlValue = (control, value) => {
      if (!control || control.value === value) return;
      const prototype = control.tagName === 'SELECT'
        ? HTMLSelectElement.prototype
        : control.tagName === 'TEXTAREA'
          ? HTMLTextAreaElement.prototype
          : HTMLInputElement.prototype;
      const setter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

      if (setter) setter.call(control, value);
      else control.value = value;

      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const setRequired = (control, required) => {
      if (!control) return;
      control.required = required;
      if (required) {
        control.setAttribute('aria-required', 'true');
      } else {
        control.removeAttribute('required');
        control.removeAttribute('aria-required');
        control.removeAttribute('data-required');
        control.setCustomValidity('');
      }
    };

    const enhanceQuoteForm = (section) => {
      const form = section.querySelector('.pmyf-form');
      if (!form) return;

      const projectType = form.querySelector('select[name="dropdown"]');
      if (projectType) {
        let customOption = projectType.querySelector('option[value="custom"]');
        if (!customOption) {
          customOption = document.createElement('option');
          customOption.value = 'custom';
          projectType.appendChild(customOption);
        }
        setControlValue(projectType, 'custom');
        const projectTypeField = projectType.closest('.pmyf-element');
        if (projectTypeField) {
          projectTypeField.hidden = true;
          projectTypeField.setAttribute('aria-hidden', 'true');
        }
      }

      setRequired(form.querySelector('input[name="fullName"]'), true);
      setRequired(form.querySelector('input[name="email"]'), true);
      setRequired(form.querySelector('textarea[name="textarea"]'), true);
      setRequired(form.querySelector('textarea[name="textarea-2"]'), true);
      setRequired(form.querySelector('input[name="attachment"]'), false);
    };

    const start = () => {
      document.querySelectorAll(sectionSelector).forEach((section) => {
        enhanceQuoteForm(section);
        if (section.dataset.gmQuoteObserved === 'true') return;
        section.dataset.gmQuoteObserved = 'true';
        const observerOptions = { childList: true, subtree: true };
        const observer = new MutationObserver(() => {
          observer.disconnect();
          enhanceQuoteForm(section);
          observer.observe(section, observerOptions);
        });
        observer.observe(section, observerOptions);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-backup-custom-quote-pre-i18n-20260830"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.gm-custom-quote';
    const setControlValue = (control, value) => {
      if (!control || control.value === value) return;
      const prototype = control.tagName === 'SELECT' ? HTMLSelectElement.prototype : control.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      const setter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
      if (setter) setter.call(control, value); else control.value = value;
      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const setRequired = (control, required) => {
      if (!control) return;
      control.required = required;
      if (required) control.setAttribute('aria-required', 'true');
      else { control.removeAttribute('required'); control.removeAttribute('aria-required'); control.removeAttribute('data-required'); control.setCustomValidity(''); }
    };
    const enhanceQuoteForm = (section) => {
      const form = section.querySelector('.pmyf-form');
      if (!form) return;
      const projectType = form.querySelector('select[name="dropdown"]');
      if (projectType) {
        let customOption = projectType.querySelector('option[value="custom"]');
        if (!customOption) { customOption = document.createElement('option'); customOption.value = 'custom'; projectType.appendChild(customOption); }
        setControlValue(projectType, 'custom');
        const projectTypeField = projectType.closest('.pmyf-element');
        if (projectTypeField) { projectTypeField.hidden = true; projectTypeField.setAttribute('aria-hidden', 'true'); }
      }
      setRequired(form.querySelector('input[name="fullName"]'), true);
      setRequired(form.querySelector('input[name="email"]'), true);
      setRequired(form.querySelector('textarea[name="textarea"]'), true);
      setRequired(form.querySelector('textarea[name="textarea-2"]'), true);
      setRequired(form.querySelector('input[name="attachment"]'), false);
    };
    const start = () => {
      document.querySelectorAll(sectionSelector).forEach((section) => {
        enhanceQuoteForm(section);
        if (section.dataset.gmQuoteObserved === 'true') return;
        section.dataset.gmQuoteObserved = 'true';
        const observerOptions = { childList: true, subtree: true };
        const observer = new MutationObserver(() => { observer.disconnect(); enhanceQuoteForm(section); observer.observe(section, observerOptions); });
        observer.observe(section, observerOptions);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-custom-quote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '.gm-custom-quote';
    const setControlValue = (control, value) => {
      if (!control || control.value === value) return;
      const prototype = control.tagName === 'SELECT' ? HTMLSelectElement.prototype : control.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      const setter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
      if (setter) setter.call(control, value); else control.value = value;
      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const setRequired = (control, required) => {
      if (!control) return;
      control.required = required;
      if (required) control.setAttribute('aria-required', 'true');
      else { control.removeAttribute('required'); control.removeAttribute('aria-required'); control.removeAttribute('data-required'); control.setCustomValidity(''); }
    };
    const enhanceQuoteForm = (section) => {
      const form = section.querySelector('.pmyf-form');
      if (!form) return;
      const projectType = form.querySelector('select[name="dropdown"]');
      if (projectType) {
        let customOption = projectType.querySelector('option[value="custom"]');
        if (!customOption) { customOption = document.createElement('option'); customOption.value = 'custom'; projectType.appendChild(customOption); }
        setControlValue(projectType, 'custom');
        const projectTypeField = projectType.closest('.pmyf-element');
        if (projectTypeField) { projectTypeField.hidden = true; projectTypeField.setAttribute('aria-hidden', 'true'); }
      }
      setRequired(form.querySelector('input[name="fullName"]'), true);
      setRequired(form.querySelector('input[name="email"]'), true);
      setRequired(form.querySelector('textarea[name="textarea"]'), true);
      setRequired(form.querySelector('textarea[name="textarea-2"]'), true);
      setRequired(form.querySelector('input[name="attachment"]'), false);
    };
    const start = () => {
      document.querySelectorAll(sectionSelector).forEach((section) => {
        enhanceQuoteForm(section);
        if (section.dataset.gmQuoteObserved === 'true') return;
        section.dataset.gmQuoteObserved = 'true';
        const observerOptions = { childList: true, subtree: true };
        const observer = new MutationObserver(() => { observer.disconnect(); enhanceQuoteForm(section); observer.observe(section, observerOptions); });
        observer.observe(section, observerOptions);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();
})();
